import './helpers.js';
import { B as BaseComponentMixin, e as registerComponent, u as use } from './plugins-4daf8ef8.js';
import { openBlock, createBlock, withKeys, withModifiers, withDirectives, createVNode, vModelRadio, renderSlot, createCommentVNode } from 'vue';
import { C as CheckRadioMixin } from './CheckRadioMixin-7636373e.js';

/**
 * Select an option from a set
 * @displayName Radio
 * @example ./examples/Radio.md
 * @style _radio.scss
 */

var script = {
  name: 'ORadio',
  mixins: [BaseComponentMixin, CheckRadioMixin],
  props: {
    rootClass: String,
    disabledClass: String,
    checkClass: String,
    labelClass: String,
    sizeClass: String,
    variantClass: String
  },
  computed: {
    rootClasses() {
      return [this.computedClass('radio', 'rootClass', 'o-radio'), {
        [`${this.computedClass('radio', 'sizeClass', 'o-size-')}${this.size}`]: this.size
      }, {
        [this.computedClass('radio', 'disabledClass', 'o-radio-disabled')]: this.disabled
      }];
    },

    checkClasses() {
      return [this.computedClass('radio', 'checkClass', 'o-radio-check'), {
        [`${this.computedClass('radio', 'variantClass', 'o-color-')}${this.variant}`]: this.variant
      }];
    },

    labelClasses() {
      return [this.computedClass('radio', 'labelClass', 'o-radio-label')];
    }

  }
};

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_ctx.vueReady)
    ? (openBlock(), createBlock("label", {
        key: 0,
        class: $options.rootClasses,
        ref: "label",
        disabled: _ctx.disabled,
        onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.focus(...args))),
        onKeydown: _cache[4] || (_cache[4] = withKeys(withModifiers($event => (_ctx.$refs.label.click()), ["prevent"]), ["enter"]))
      }, [
        withDirectives(createVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.computedValue = $event)),
          type: "radio",
          ref: "input",
          onClick: _cache[2] || (_cache[2] = withModifiers(() => {}, ["stop"])),
          disabled: _ctx.disabled,
          required: _ctx.required,
          name: _ctx.name,
          value: _ctx.nativeValue
        }, null, 8 /* PROPS */, ["disabled", "required", "name", "value"]), [
          [vModelRadio, _ctx.computedValue]
        ]),
        createVNode("span", { class: $options.checkClasses }, null, 2 /* CLASS */),
        createVNode("span", { class: $options.labelClasses }, [
          renderSlot(_ctx.$slots, "default")
        ], 2 /* CLASS */)
      ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, ["disabled"]))
    : createCommentVNode("v-if", true)
}

script.render = render;
script.__file = "oruga/src/components/radio/Radio.vue";

const Plugin = {
  install(Vue) {
    registerComponent(Vue, script);
  }

};
use(Plugin);

export default Plugin;
export { script as ORadio };
